import Marionette from 'backbone.marionette';
import watchedBillCategoryItemViewTmpl from '../templates/category_list_itemview.tpl';
export default Marionette.ItemView.extend({
  template: watchedBillCategoryItemViewTmpl,
  className: 'watched-bill col'
});